import { Component, OnInit, EventEmitter, Output, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';

import { UIComponentsTheme } from 'app/ui-components/ui-components-theme.enum';

import { TemplateSelectorViewTypes } from '../template-selector-view-types.enum';

@Component({
  selector: 'cc-templates-selector-tool-bar',
  templateUrl: 'templates-selector-tool-bar.component.html',
  styleUrls: ['templates-selector-tool-bar.scss'],
})
export class TemplatesSelectorToolBarComponent implements OnInit, OnDestroy {
  @Input() viewType: TemplateSelectorViewTypes;
  @Input() showClearFiltersBtn: boolean;

  @Output() search = new EventEmitter();
  @Output() changedViewType = new EventEmitter();
  @Output() filtersCleared = new EventEmitter();

  templateSelectorViewTypes = TemplateSelectorViewTypes;

  readonly searchInputTheme = UIComponentsTheme.White;
  readonly searchDebounce = 200;
  destroy$ = new Subject<void>();

  ngOnInit(): void {}

  searchKeyword(keyword: string) {
    this.search.emit(keyword);
  }

  changeView(type: TemplateSelectorViewTypes) {
    this.viewType = type;
    this.changedViewType.emit(type);
  }

  clearFilters() {
    this.filtersCleared.emit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
